$(document).on('click', '.cart-show-variation', function(){
	let parent = $(this).parents('td.product-name');
	$(this).toggleClass('show');
	parent.find('.variation').toggle();
});

$('.checkout-company-field').change(function(){
	let taxType = $('.checkout-tax-type_radio:checked').val();
	let companyNumber = $('#company_number').val();
	let hasCompany = $('#has_company').is(':checked');

	$.ajax({
		type: 'POST',
		url: kampa.ajax_url,
		data: {
			action: 'kampa_checkout_type_change',
			tax_type: taxType,
			company_number: companyNumber,
			has_company: hasCompany ? 'on' : '',
		},
		complete: function (res) {
			$(document.body).trigger('update_checkout'); // Refresh checkout
		},
	});
});

toggleCompanyDetails();
$('#has_company').change(toggleCompanyDetails);
function toggleCompanyDetails(){
	let companyDetails = $('#checkout-company-details');
	if($('#has_company').is(':checked')) companyDetails.slideDown();
	else companyDetails.slideUp();
}

handleBillingCountry();
$('#billing_country').change(handleBillingCountry);
function handleBillingCountry(){
	let customerCountry = $('#billing_country').val();
	let taxTypes = $('#checkout-tax-types');
	if(customerCountry != kampa.shop_country) taxTypes.show();
	else taxTypes.hide();
}

$(document).on('click','#checkout-create-offer',function(e){
	e.preventDefault();
	let form = $('form.woocommerce-checkout')[0];
	let formData = new FormData(form);

	formData.append('action','kampa_create_offer');

	$.ajax({
		type: 'POST',
		url: kampa.ajax_url,
		data: formData,
		processData: false,
		contentType: false,
		complete: function(res) {
			$(document.body).trigger('update_checkout'); // Refresh checkout
		},
	});
});



// WEBPACK FOOTER //
// ./scripts/checkout/_checkout.js